import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color0: '#ffffff',
    color50: '#fcfcfc',
    color100: '#f0f3f3',
    color200: '#f3f3f4',
    color300: '#e6e7e8',
    color400: '#c4c5c1',
    color500: '#a3a49a',
    color600: '#818272',
    color700: '#5f604b',
    color800: '#3f4032',
    color900: '#202019'
  },
  default: {
    color50: '#d5e4f1',
    color100: '#aac9e3',
    color200: '#80aed5',
    color300: '#6C92BB',
    color400: '#3B6EA5',
    color500: '#0A4A8E',
    color600: '#004a88',
    color700: '#003866',
    color800: '#002544',
    color900: '#001322'
  },
  accent: {
    color50: '#eef5fb',
    color100: '#dceaf7',
    color200: '#cbe0f3',
    color300: '#b9d5ee',
    color400: '#a8cbea',
    color500: '#96c0e6',
    color600: '#789ab8',
    color700: '#5a738a',
    color800: '#3c4d5c',
    color900: '#1e262e'
  },
  positive: {
    color50: '#dae6e1',
    color100: '#bdd9ce',
    color200: '#97bfb0',
    color300: '#6fa38f',
    color400: '#438a6e',
    color500: '#006E43',
    color600: '#196346',
    color700: '#134733',
    color800: '#0e3626',
    color900: '#071f16'
  },
  negative: {
    color50: '#fdeadb',
    color100: '#fcd5b6',
    color200: '#fac092',
    color300: '#f8aa6e',
    color400: '#f79549',
    color500: '#C41E3A',
    color600: '#c4661e',
    color700: '#934d16',
    color800: '#62330f',
    color900: '#311a07'
  },
  special: {
    color50: '#fdeadb',
    color100: '#fcd5b6',
    color200: '#fac092',
    color300: '#66A88E',
    color400: '#057349',
    color500: '#006E43',
    color600: '#c4661e',
    color700: '#F0F3F3',
    color800: '#62330f',
    color900: '#311a07'
  }
};

const variant: ACPVariant = {
  id: 'www.brinksarmored.com',
  productTitle: "Brink's Armored Account",
  productType: 'consumer_dda',
  accessDomain: {
    subdomain: 'www',
    domain: 'brinksarmored',
    topLevelDomain: 'com'
  },
  colors,
  themeConfiguration: {
    acpActivationAppBar: {
      defaultBackgroundColor: colors.neutral.color0
    },
    acpRisingTideLayout: {
      appBarDefaultBackgroundColor: colors.neutral.color0
    }
  },
  legacyAcpTheme: 'brinks-armored',
  legacyLegosTheme: 'generic-theme',
  legacyAcpBrandName: 'brinksarmored',
  status_bar_background_color: colors.neutral.color0,
  status_bar_foreground_color: 'light',
  contactInfo: {
    name: "Brink's Armored",
    contact_address_line1: 'P.O. Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@brinksarmored.com',
    fax_formatted: '(866) 358-0526',
    phone_formatted: '1-855-201-1352',
    phone: '18552011352',
    phone_international: '737-220-8956',
    balance_check_phone: '18339541605',
    balance_check_phone_formatted: '1-833-954-1605',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: true,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: false,
      showScanCardRegistration: false,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: true,
      showWUTransfers: false,
      showReloadLocationLink: false
    },
    misc: {
      atmNetwork: 'BrinksArmored',
      distributor: 'brinks_gpr',
      layoutComponentOverride: false,
      layoutAppBarInverted: true,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#0092BC',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.brinksarmored.com',
      marketingSiteLinkText: 'Brinksarmored.com',
      locationSearchMax: '25'
    },
    content: {
      copyrightStatement:
        'Netspend Corporation All rights reserved worldwide. Netspend is the federally registered U.S. service mark of Netspend Corporation All other trademarks and service marks belong to their owners.',
      mastercardStatement:
        'Mastercard and the circles design are registered trademarks of Mastercard International Incorporated.'
    },
    disclaimers: {
      overdraftDisclaimer: `The Debit Card Overdraft Service is an optional service made available to eligible Brink's Armored Account customers by Pathward, N.A. Once you enroll and meet the eligibility requirements, you will be charged $20.00 for each transaction that overdraws your account by more than $10.00, up to a maximum of five (5) fees per calendar month. To avoid that fee, you have twenty-four (24) hours from the time of the first transaction that creates the overdraft to bring your Account back to a zero ($0.00) or a positive balance. Transactions subject to an overdraft fee are signature and PIN purchase transactions and ATM transactions. ACH Debit transactions are not eligible for coverage. Any negative balance must be repaid within thirty (30) days. <b>Whether we authorize an overdraft is discretionary, and we reserve the right not to pay.</b> For example, we typically will not pay overdrafts if you fail to meet the eligibility requirements for this service or you attempt too many transactions or transactions that create too large of an overdraft. Call us at 1-855-201-1352 or log in to your Online Account Center for additional terms and conditions that apply, including initial and ongoing eligibility requirements for the service. <b>This service is expensive, so we encourage you to research alternatives before enrolling.</b> Once enrolled, you may opt-out at any time; however, you are responsible to repay any overdrawn amounts on your account even if you opt-out of the service.`
    },
    sections: [
      'activation',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'atm-finder',
      'bank-transfers',
      'card',
      'change-password',
      'change-username',
      'checks',
      'check-deposit',
      'close-account',
      'connected-banks',
      'dashboard',
      'digital-wallet',
      'direct-deposit',
      'direct-deposit-form',
      'direct-deposit-mobile-panel',
      'disclosure-dictionary',
      'dynamic-faq',
      'echecks',
      'feedback',
      'feeplan',
      'file-dispute',
      'fraud-detection',
      'handoff',
      'interstitials',
      'layout',
      'locations',
      'login',
      'logout',
      'manage-gpr',
      'me-to-me-transfer',
      'mobile-check-load',
      'money-gram',
      'move-money',
      'offers',
      'overdraft',
      'post-install-multi-screen-acquisition-flow',
      'refer-a-friend',
      'savings',
      'secure-inbox',
      'secure-upload',
      'security',
      'spend-money',
      'spending-tracker',
      'survey',
      'post-handoff-to-activate-register'
    ]
  }
};

export default variant;
